import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ConvertMetersPipe, Shop } from '@us/web/shared/data-access';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiSvgModule } from '@taiga-ui/core';
import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { TuiDestroyService, tuiIsPresent, TuiLetModule } from '@taiga-ui/cdk';
// TODO: fix Circular dependency
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CategoriesComponent } from '@us/web/categories/feature';
import { OpenTimeToDayPipe, selectSelectedShop, ShopsActions } from '@us/web/shops/data-access';
import { selectCurrentLocation } from '@us/web/position/data-access';
import { distinctUntilChanged, filter, map, Observable, switchMap, takeUntil, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { RouterUtil, RouteUtil } from '@us/web/shared/utils';
import { FormatPipeModule, IsFuturePipeModule, IsTodayPipeModule, ParseIsoPipeModule } from 'ngx-date-fns';
import { BannersV2Component } from '@us/web/shop/feature';
import { BreadcrumbsComponent } from '@us/web/shared/ui';

@Component({
    selector: 'us-shop',
    standalone: true,
    imports: [
        ConvertMetersPipe,
        TranslocoModule,
        TuiSvgModule,
        NgIf,
        OpenTimeToDayPipe,
        AsyncPipe,
        JsonPipe,
        TuiLetModule,
        CategoriesComponent,
        OpenTimeToDayPipe,
        IsFuturePipeModule,
        ParseIsoPipeModule,
        FormatPipeModule,
        IsTodayPipeModule,
        BannersV2Component,
        BreadcrumbsComponent
    ],
    providers: [TuiDestroyService],
    templateUrl: './shop.component.html',
    styleUrls: ['./shop.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopComponent implements OnInit {
    private readonly store = inject(Store);
    private readonly route = inject(ActivatedRoute);
    private readonly destroy$ = inject(TuiDestroyService, { self: true });

    private readonly shopIdParams$: Observable<string> = this.route.params.pipe(
        map(params => params[RouterUtil.Cog.ShopId]),
        filter(tuiIsPresent),
        distinctUntilChanged()
    );

    readonly shop$: Observable<Shop | null> = this.shopIdParams$.pipe(
        tap(shopId => {
            this.store.dispatch(ShopsActions.selectShop({ shopId }));
        }),
        switchMap(() => this.store.select(selectSelectedShop))
    );

    readonly RouteUtil = RouteUtil;

    ngOnInit() {
        this.store
            .select(selectCurrentLocation)
            .pipe(
                takeUntil(this.destroy$),
                // startWith(undefined),
                distinctUntilChanged(),
                tap(location => {
                    this.store.dispatch(ShopsActions.loadShops(location || {}));
                })
            )
            .subscribe();
    }
}
